import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import { iNotificationWorkflowNode } from "@sdk/wa-holiday-notification-workflows/wa-holiday-notification-workflows-models";
import React from "react";

const WorkflowNodeEditorModal = React.lazy(
  () => import("./workflow-node-editor.modal"),
);

const WorkflowNodeEditor: iModalProps<
  typeof WorkflowNodeEditorModal,
  {
    onSave: (action: Partial<iNotificationWorkflowNode>) => any;
    initialValue?: Partial<iNotificationWorkflowNode>;
  }
> = {
  name: "workflow-node-editor",
  component: GenerateModalWithSuspense(WorkflowNodeEditorModal),
};

export default WorkflowNodeEditor;
